import React from 'react';

import css from './action-button.module.scss';

interface Props {
  ref: React.Ref<HTMLButtonElement>;
  decorRef?: React.Ref<HTMLDivElement>;
  onMouseDown: () => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
  onTouchStart: () => void;
  onTouchEnd: () => void;
}

export const ActionButton: React.FC<Props> = ({
  ref,
  decorRef,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  onTouchStart,
  onTouchEnd,
}) => {
  return (
    <>
      <button
        className={css.button}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        ref={ref}
      />
      <div className={css.decor} ref={decorRef} />
    </>
  );
};
